import CurrencyFormatter from '../utils/CurrencyFormatter';

export default function formatCurrency(value) {
  return CurrencyFormatter.format(value);
}
